import newSelectionButtons from "./new-selection-buttons";
import fwEditableZoomDropdown from "./fw-editable-zoom-dropdown"
import fwOpenLocalFiles from "./fw-open-local-files"
import fwCreateMeasureDropdown from "./fw-create-measure-dropdown"
import fwDownloadButton from "./fw-downloadButton"
import fwConvertToPdf from "./fw-convert-to-pdf"


function newWidgats() {
  // let rootModule = window.UIExtension.modular.root();
  // TODO FOXIT 所有云编辑项目使用的自建的组件定义在新的module:fw-module下
  let fwModule = window.UIExtension.modular.module('fw-module', []);
  [
    newSelectionButtons,
    fwEditableZoomDropdown,
    fwOpenLocalFiles,
    fwCreateMeasureDropdown,
    fwDownloadButton,
    fwConvertToPdf
  ].forEach(componentConfigs => {
    if(!Array.isArray(componentConfigs)) {
        componentConfigs = [componentConfigs];
    }
    componentConfigs.forEach(componentConfig => {
      fwModule.registerFragment(componentConfig.name, componentConfig.fragment)
    });
  })
  let fragments = []
  return {fragments};
}

export { newWidgats }; //RemoveModuleFn,